import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getIsInNonDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import MobileSidebarOverlay from './MobileSidebarOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
const MobileSidebarOverlayContainer = ({
  modalMessageKey,
  hasSmartRuleSelected,
  contextual = true
}) => {
  const isInNonDefaultBreakpointMode = useSelector(getIsInNonDefaultBreakpointMode);
  if (isInNonDefaultBreakpointMode || hasSmartRuleSelected) {
    return /*#__PURE__*/_jsx(MobileSidebarOverlay, {
      modalMessageKey: modalMessageKey,
      messageTitle: hasSmartRuleSelected ? 'addModule.smartRulesStyles.title' : 'addModule.mobile.title',
      contextual: contextual
    });
  }
  return null;
};
MobileSidebarOverlayContainer.propTypes = {
  modalMessageKey: PropTypes.string.isRequired,
  hasSmartRuleSelected: PropTypes.number,
  contextual: PropTypes.bool
};
export default MobileSidebarOverlayContainer;